export default __webpack_public_path__ + "static/roadmap-458577da0ee9a8420456eff1a1ebc160.png";